module.exports = __webpack_public_path__ + "icon_01.svg?c6bfc986a4cc42a524b47a21de8ff646";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_01.svg
// module id = 143
// module chunks = 0